import { render, staticRenderFns } from "./ManageUserDetailsPage.vue?vue&type=template&id=4a49d602"
import script from "./ManageUserDetailsPage.vue?vue&type=script&lang=ts"
export * from "./ManageUserDetailsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports